import React from 'react'

import Segment from './SegmentFull'

const Segments = ({ segments }) => {
  return segments.map((item, i) => 
    <Segment params={item.params} data={item.data} download key={i} />
  )
}

export default Segments


// WEBPACK FOOTER //
// ./src/components/Segments.js